// const base = '//us-central1-insurbot-5754a.cloudfunctions.net/'
const base = 'https://cibankdemo-server-1908.herokuapp.com/'

// Send Single Message to Single User
function sendMsg(content) {
  const def = {
    platform: 'webPopup',
    userID: 2051557634917072,
    message: 'Someone sent somethings from dashboard but forgot to type stuff',
  }
  content = content || def
  return new Promise((resolve) => {
    fetch(base + 'dashboard/sendMsg', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(content),
    })
      .then((response) => {
        let resObj = response.json()
        resolve(resObj)
      })
  })
}

// Send Single Message to a Group
function sendMsgGroup(content) {
  const def = {
    platform: 'webPopup',
    campaignGroup: 'demo',
    campaign: 'Someone sent somethings from dashboard to everyone but forgot to type stuff',
  }
  content = content || def
  return new Promise((resolve) => {
    fetch(base + 'dashboard/sendCampaign', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(content),
    })
      .then((response) => {
        let resObj = response.json()
        resolve(resObj)
      })
  })
}

// Cancel Countdown when Agent Replies
function cancelCountdown(userID) {
  return new Promise((resolve) => {
    fetch(base + 'dashboard/cancelStump', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userID: userID }),
    })
      .then((response) => {
        let resObj = response.json()
        resolve(resObj)
      })
  })
}

// Get Server Countdown
function getCountdown(userID, flagKey) {
  return new Promise((resolve) => {
    fetch(base + 'dashboard/remainingFlagTime', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userID, flagKey }),
    })
      .then((response) => {
        let resObj = response.json()
        resolve(resObj)
      })
  })
}

function pauseAll() {
  fetch(base + 'dashboard/pauseAll')
}

function resumeAll() {
  fetch(base + 'dashboard/resumeAll')
}

function assignUserIDnewestChat(newestChatKey) {
  fetch(base + 'dashboard/assignUserIDnewestChat?nck=' + newestChatKey)
}

function recordDataLog(action, path, logBody, nnk) {
  var noNewKey = nnk || false
  let body = {
    action,
    path,
    logBody,
    noNewKey,
  }
  return new Promise((resolve) => {
    fetch(base + 'dashboard/recordDataLog', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    }).then((res) => {
      resolve(res.json())
    })
  })
}

function deleteDFIntents(intent) {
  return new Promise((resolve) => {
    fetch(base + 'intents/deleteIntent', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(intent),
    }).then((res) => {
      resolve(res.json())
    })
  })
}

function getDFIntents() {
  return new Promise((resolve) => {
    fetch(base + 'intents/getDialogflowIntents').then((response) => {
      resolve(response)
    })
  })
}
function patchDFIntents(intentDetails) {
  return new Promise((resolve) => {
    console.log('Patching Intent', intentDetails)
    fetch(base + 'intents/editIntent', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(intentDetails),
    }).then((res) => {
      resolve(res.json())
    })
  })
}

function createDFIntents(intentsObj) {
  return new Promise((resolve) => {
    fetch(base + 'intents/createDialogflowIntents', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(intentsObj),
    }).then((res) => {
      resolve(res.json())
    })
  })
}

function translateServer(translateObject) {
  return new Promise((resolve) => {
    fetch(base + 'webEntry/translateWebhook', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({translateObject}),
    }).then((res) => {
      resolve(res.json())
    })
  })
}

export {
  sendMsg as send,
  sendMsgGroup as blast,
  cancelCountdown,
  getCountdown,
  pauseAll,
  resumeAll,
  assignUserIDnewestChat,
  recordDataLog,
  getDFIntents,
  createDFIntents,
  deleteDFIntents,
  patchDFIntents,
  translateServer,
}



// WEBPACK FOOTER //
// ./src/api.js